import Marquee from "react-fast-marquee";
import { Star, BadgeCheck, ShieldCheck, Truck, Award } from "lucide-react";
import { PRESS } from "@/data/content";

const PRESS_STYLE = {
  "VOGUE": "font-display text-2xl font-medium uppercase tracking-[0.35em]",
  "ELLE": "font-display text-2xl font-bold uppercase tracking-[0.3em]",
  "Harper's BAZAAR": "font-display text-xl tracking-wide",
  "marie claire": "font-display text-2xl italic lowercase tracking-tight",
  "COSMOPOLITAN": "font-sans text-xl font-extrabold uppercase tracking-tight",
  "BEAUTY CREW": "font-sans text-lg font-semibold uppercase tracking-[0.18em]",
};

const TRUST = [
  [Star, "4.9 / 5", "50+ five-star reviews"],
  [BadgeCheck, "Verified", "Real customer purchases"],
  [ShieldCheck, "30 Nights", "Money-back guarantee"],
  [Truck, "Free", "Express shipping"],
  [Award, "1 Year", "Warranty included"],
];

export const TrustBar = () => (
  <section className="border-b border-[#F2E8E6] bg-white" data-testid="trust-bar">
    <div className="border-b border-[#F2E8E6] bg-[#FFF0E8]">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 gap-y-7 px-6 py-9 sm:grid-cols-3 md:grid-cols-5 md:px-12">
        {TRUST.map(([Icon, big, small]) => (
          <div key={small} className="flex items-center justify-center gap-3" data-testid={`trust-item-${big.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <Icon className="h-6 w-6 flex-none text-[#FBC4A8]" strokeWidth={1.5} />
            <div className="leading-tight">
              <p className="text-sm font-semibold text-[#2C2B2C]">{big}</p>
              <p className="text-[0.7rem] font-light text-[#8A7F86]">{small}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="overflow-hidden py-7">
      <p className="mb-5 text-center text-[0.62rem] uppercase tracking-[0.3em] text-[#8A7F86]">As Seen On</p>
      <Marquee gradient gradientColor="#FFFFFF" gradientWidth={100} speed={26}>
        {PRESS.concat(PRESS).map((p, i) => (
          <span key={i} className={`mx-10 text-[#2C2B2C] ${PRESS_STYLE[p] || "font-display text-xl"}`}>{p}</span>
        ))}
      </Marquee>
    </div>
  </section>
);
